import React from 'react';
// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";

// import Breadcrumb from "../../Breadcrumb/Main";
// import Header from "../../headerone/Main";
import { Container, Row, Col } from 'react-bootstrap'; // Import Container, Row, and Col from the correct source
import { Link } from 'react-router-dom';



function Committees() {
    return (
        <>
            <section className="project-detail">
                <Container>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb-50 wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h3>Committees</h3>
                            </div>
                        </div>
                    </div>
                  
                 
                        
                       
                        <Row>
                            <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/internalcomplaintcommittee" className="c-link">Internal Complaints Committee</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/internalcomplaintcommittee" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/grievance_redressal_committee" className="c-link">Grievance Redressal Committee</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div> 
                            
                        </Row>
                        <Row className='mt-5'>
                            <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/liaison-officers" className="c-link">SC/ST/OBC Liaison Officers / Cell</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/liaison-officers" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/anti-ragging" className="c-link">Anti-Ragging Committee</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/anti-ragging" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                           
                     
                                
                               
                        </Row>
                        <Row className='mt-5'>
                        <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/differently_abled_support_service_cell" className="c-link">Differently Abled Support Service Cell</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/differently_abled_support_service_cell" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                             <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/equal_opportunity_cell" className="c-link">Equal Opportunity Cell</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/differently_abled_support_service_cell" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                            
                     
                                
                               
                        </Row>
                        <Row className='mt-5'>
                             <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/Timetable_Committee" className="c-link">Timetable Committee</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/liaison-officers" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="services-box">
                                    <h3><Link to="/senior-purchase-committee" className="c-link">Senior Purchase Committee</Link></h3>
                                    {/* <div className="services-content2">
                                        <Link to="/liaison-officers" className="c-link">Click here</Link>
                                    </div> */}
                                </div>
                            </div>
                                                          
                        </Row>
                        <Row className='mt-5'>
                            <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/overseeing_waste_management_system" className="c-link">Overseeing Waste Management System </Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/disciplinary_welfare_committee" className="c-link">Disciplinary and Welfare Committee</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div> 
                        </Row>
                        <Row className='mt-5'>
                            <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/school_management_committee" className="c-link">School Management Committee</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/outsourcing_contractual_adhoc_employee_committee" className="c-link">Outsourcing / Contractual / Adhoc Employee Committee</Link></h3>
                                        
                                    </div>
                                </div> 
                        </Row>
                        <Row className='mt-5'>
                            <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/mental_health_and_well_being_monitoring_committee" className="c-link">Mental Health and Well-being Monitoring Committee</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/Library_Advisory_Committee" className="c-link">Library Advisory Committee</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                                 
                        </Row>
                        <Row className='mt-5'>
                            <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/Service_Matters_Committee" className="c-link">Service Matters Committee</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/RPN_Committee" className="c-link">RPN, Creation of Posts and Roster Verification Committee</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                                 
                        </Row>
                        <Row className='mt-5'>
                            <div className="col-lg-6 col-md-6">
                                    <div className="services-box">
                                        <h3><Link to="/obc_cell" className="c-link">OBC Cell</Link></h3>
                                        {/* <div className="services-content2">
                                            <Link to="/disciplinary_welfare_committee" className="c-link">Click here</Link>
                                        </div> */}
                                    </div>
                                </div>
                                
                                 
                        </Row>

                    
                </Container> {/* container */}
            </section>
        </>
    )
}

export default Committees;
